import { CommonResponse } from "@gtpl/shared-models/production-management";
import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { AssetAssignmentTransactionDto } from "./dto/asset-assignment-transaction.dto";
import { Between, getManager, IsNull, Not, Repository } from "typeorm";
import { AssetAssignmentDto } from "./dto/asset-assignment.dto";
import { AssetAssignmentTransaction } from "./entity/asset-assignment-transaction.entity";
import { AssetAssignmentAdapter } from "./entity/asset-assignment.adapter";
import { AssetAssignment } from "./entity/asset-assignment.entity";
import moment from "moment";
import { notEquals } from "class-validator";
import { AssetByCode } from './dto/asset-by-code.dto';
import { Assets } from "../open-assets/open-assets-entity";
import { AssetLocationMappingRepository } from "../asset-location-mapping/repository/asset-location-mapping.repository";
import { AssetMaintainanceService } from "../asset-maintainance/asset-maintainance.service";
import { AssetsRepository } from "../open-assets/dto/opens-assets-repository";
import { Location } from '../../app/locations/dto/loction-entity'
import appSettings from "apps/services/config";
import { AssetByDate } from "./dto/asset-by-date.dto";
import { AssetStatusEnum } from "libs/shared-models/common-models/src/lib/enum/asset-status.enum";
import { AssetByAssetCode } from "./dto/get-by-assetCode.dto";
import { AssetAssignmentDto as AssignmentDto } from 'libs/shared-models/asset-management/src/lib/asset-assignment/asset-assignment.dto';
import { AssetAssignmentTransactionDto as AssignmentTransactionDto } from 'libs/shared-models/asset-management/src/lib/asset-assignment/asset-assignment-transaction.dto';
import { AssetsId } from "../open-assets/dto/asset-id-req";
import { AssetServiceReq, ErrorResponse, GlobalVariableValues, MessageParameters, UnitRequest } from "@gtpl/shared-models/common-models";
import whatsApp from "apps/services/whatsapp";
import { WhatsAppNotificationService } from "@gtpl/shared-services/notification-management";
import { AssetRequistion } from "../asset-requistion/entity/asset-requisition.entity";
import { AssetTransaction } from "../open-assets/asset-transaction-entity";
import { AssetTransactionDto } from "../open-assets/dto/asset-transaction-dto";
import { AssetTransactionAdapter } from "../open-assets/dto/asset-transaction-adapter";

import { WhatsappBroadCastService } from '@gtpl/shared-services/whatsapp-broad-cast';
import { WhatsAppLogDto } from '@gtpl/shared-models/whatsapp-broad-cast';
@Injectable()
export class AssetAssignmentService {
    constructor(
        private adapter: AssetAssignmentAdapter,
        @InjectRepository(AssetAssignment)
        private repo: Repository<AssetAssignment>,
        @InjectRepository(AssetAssignmentTransaction)
        private transRepo: Repository<AssetAssignmentTransaction>,
        private locationMapRepo: AssetLocationMappingRepository,
        private maintanaceService: AssetMaintainanceService,
        // private assetsRepository: AssetsRepository
        @InjectRepository(Assets)
        private assetsRepository: Repository<Assets>,
        private wpService: WhatsAppNotificationService,
        @InjectRepository(AssetRequistion)
        private assetsRequistionRepo: Repository<AssetRequistion>,
        @InjectRepository(AssetTransaction)
        private assetsTransactionRepo: Repository<AssetTransaction>,
        private assetTransAdapter: AssetTransactionAdapter,
        private wtsAppBroadCatService:WhatsappBroadCastService,

    ) { }

    async createCheckIn(createDto: AssetAssignmentDto): Promise<CommonResponse> {
        const assetLocationMappingObj: { asset_id: number, asset_location_id: number } = await this.locationMapRepo.createQueryBuilder('asset_loc')
            .select('assets.asset_id, asset_location_id')
            .leftJoin('asset_loc.assetsId', 'assets')
            .where(`assets.assets_code = '${createDto.assetsCode}'`)
            .getRawOne();
        const actAssetId = Number(assetLocationMappingObj.asset_id);
        if (!createDto.checkOut) {
            await this.maintanaceService.isAssetUserAssignmentForCheckIn(actAssetId);
        } else {
            await this.maintanaceService.isAssetUserAssignmentForCheckout(actAssetId);
        }
        let assetAssignmentId = 0;
        const assetCheck = await this.repo.findOne({ where: { assetsId: actAssetId } })
        if (assetCheck) {
            const assetAssignmentUpdate = await this.repo.update({ assetAssignmentId: assetCheck.assetAssignmentId }, { assetLocationId: assetLocationMappingObj.asset_location_id, employeeId: createDto.employeeId, checkIn: moment(Date.now()).format('YYYY-MM-DD HH:mm:ss'), checkOut: null })
            assetAssignmentId = assetCheck.assetAssignmentId;
        } else {
            const assetsId = new Assets();
            assetsId.assetId = actAssetId;
            const locationMappingRepo = await this.locationMapRepo.findOne({ assetsId: assetsId });
            const assetOwner = new AssetAssignment();
            assetOwner.assetsId = assetsId;
            assetOwner.assetLocationId = locationMappingRepo.assetLocationId;
            assetOwner.checkIn = new Date();
            assetOwner.checkinReason = createDto.checkinReason;
            assetOwner.createdUser = createDto.createdUser;
            assetOwner.employeeId = createDto.employeeId;
            const assetAssignmentSave = await this.repo.save(assetOwner)
            assetAssignmentId = assetAssignmentSave.assetAssignmentId;
            if (assetAssignmentSave) {
                const manager = getManager()
                let qry = `SELECT asas.asset_id,it.item_name AS assets_name,aas.assets_code, emp.employee_name,emp.department_id,dep.dept_name,asas.employee_id FROM ` + appSettings.assets_db + `.asset_assignment asas LEFT JOIN ` + appSettings.masters_db + `.employee_details emp ON emp.employee_id = asas.employee_id LEFT JOIN ` + appSettings.assets_db + `.assets aas ON aas.asset_id = asas.asset_id LEFT JOIN ` + appSettings.masters_db + `.items it ON it.item_id = aas.assets_name LEFT JOIN ` + appSettings.masters_db + `.departments dep ON dep.dept_id = emp.department_id WHERE asas.asset_assignment_id = '${assetAssignmentSave.assetAssignmentId}' `
                const data = await manager.query(qry);
                const parameters = [
                    { "type": "text", "text": moment().format('DD-MM-YYYY') },
                    { "type": "text", "text": data[0].assets_name ? data[0].assets_name : "No Data" },
                    { "type": "text", "text": data[0].assets_code ? data[0].assets_code : "No Data" },
                    { "type": "text", "text": data[0].employee_name ? data[0].employee_name : "No Data" },
                    { "type": "text", "text": data[0].dept_name ? data[0].dept_name : "No Data" },
                ];
                for (const contact of whatsApp.contacts) {
                    let statusFlag = true
                    const req = await new MessageParameters(contact, 'asset_assign', parameters, "en_us")
                    const messageStatus = await this.wpService.sendMessageThroughFbApi(req);
                    if (!messageStatus.status) {
                        statusFlag = false
                    }
                    else
                    {
                        const whatsapplogDto = new WhatsAppLogDto(contact,'asset_assign','Brandix_assets',GlobalVariableValues.assetmanagementcompanyId,GlobalVariableValues.assetManagementmoduleId)
                        await this.wtsAppBroadCatService.createWhatappLog(whatsapplogDto)
                    }

                }
            }

        }
        const transDto = new AssetAssignmentTransactionDto();
        transDto.assetAssignmentId = assetAssignmentId;
        transDto.assetLocationId = assetLocationMappingObj.asset_location_id;
        transDto.employeeId = createDto.employeeId;
        transDto.checkIn = new Date();
        transDto.checkinReason = createDto.checkinReason;
        transDto.checkOut = createDto.checkOut;
        transDto.assetsId = actAssetId;
        transDto.status = 'CHECKIN'
        const transEntity = this.adapter.convertDtoToAssetAssignmentTransactionEntity(transDto)
        const assetAssignmentTrans = await this.transRepo.save(transEntity);
        const statusSave = await this.assetsRepository.update({ assetId: actAssetId }, { status: AssetStatusEnum.INUSE, lastCheckIn: moment(Date.now()).format('YYYY-MM-DD HH:mm:ss'), employeeId: createDto.employeeId, transactionDate: moment(Date.now()).format('YYYY-MM-DD HH:mm:ss') })
        const requestSave = await this.assetsRequistionRepo.update({requestId: createDto.requestId},{assetName:actAssetId,status:AssetStatusEnum.COMPLETED})
        const assetTransDto = new AssetTransactionDto();
        assetTransDto.employeeId = createDto.employeeId;
        assetTransDto.lastCheckIn = new Date();
        assetTransDto.status = AssetStatusEnum.INUSE;
        assetTransDto.assetId = actAssetId;
        assetTransDto.transactionDate = new Date();
        const assetTransEntity = this.assetTransAdapter.convertAssetTransactionDtoToEntity(assetTransDto)
        const statusTransactionSave = await this.assetsTransactionRepo.save(assetTransEntity)
        return new CommonResponse(true, 1, 'Successfully created', assetAssignmentTrans)

    }


    async updateCheckOut(req: AssetAssignmentDto): Promise<CommonResponse> {
        const assetLocationMappingObj: { asset_id: number, asset_location_id: number } = await this.locationMapRepo.createQueryBuilder('asset_loc')
            .select('assets.asset_id, asset_location_id')
            .leftJoin('asset_loc.assetsId', 'assets')
            .where(`assets.assets_code = '${req.assetsCode}'`)
            .getRawOne();
        const actAssetId = Number(assetLocationMappingObj.asset_id);
        const updateCheck = await this.repo.findOne({ where: { assetsId: actAssetId } })
        if (!updateCheck) {
            return new CommonResponse(false, 99898, 'Asset not found')
        } else {
            const updateChecksave = await this.repo.update({ assetAssignmentId: updateCheck.assetAssignmentId }, { checkOut: moment(Date.now()).format('YYYY-MM-DD'), checkOutReason: req.checkOutReason });
            const updateTransCheck = await this.transRepo.findOne({ where: { assetsId: actAssetId, checkOut: null } })
                const manager = getManager()
                let qry = `SELECT asas.asset_id,it.item_name AS assets_name,aas.assets_code, emp.employee_name,emp.department_id,dep.dept_name,asas.employee_id FROM ` + appSettings.assets_db + `.asset_assignment asas LEFT JOIN ` + appSettings.masters_db + `.employee_details emp ON emp.employee_id = asas.employee_id LEFT JOIN ` + appSettings.assets_db + `.assets aas ON aas.asset_id = asas.asset_id LEFT JOIN ` + appSettings.masters_db + `.items it ON it.item_id = aas.assets_name LEFT JOIN ` + appSettings.masters_db + `.departments dep ON dep.dept_id = emp.department_id WHERE asas.asset_assignment_id = '${updateCheck.assetAssignmentId}' `
                const data = await manager.query(qry);
                console.log(data,'------------------dataa')
                const parameters = [
                    { "type": "text", "text": moment().format('DD-MM-YYYY') },
                    { "type": "text", "text": data[0].assets_name ? data[0].assets_name : "No Data" },
                    { "type": "text", "text": data[0].assets_code ? data[0].assets_code : "No Data" },
                    { "type": "text", "text": data[0].employee_name ? data[0].employee_name : "No Data" },
                    { "type": "text", "text": data[0].dept_name ? data[0].dept_name : "No Data" },
                ];
                for (const contact of whatsApp.contacts) {
                    let statusFlag = true
                    const req = await new MessageParameters(contact, 'asset_check_out', parameters, "en_us")
                    const messageStatus = await this.wpService.sendMessageThroughFbApi(req);
                    console.log(messageStatus, 'ppppp')
                    if (!messageStatus.status) {
                        statusFlag = false
                    }
                    else {
                        const testdata = 'INSERT INTO ' + appSettings.whatsapp_db + '.whatsapp_logs (contact_no,template_name,project_name,company_id,module_id) VALUES("' + contact + '","asset_assign","Brandix_assets",' + GlobalVariableValues.companyId + ',' + GlobalVariableValues.assetManagementmoduleId + ')'
                        const result = await manager.query(testdata)
                        const res = new CommonResponse(true, 1111, "Data retreived sucesssfuly", result)
                    }

            }
            // if(updateTransCheck){
            // const updateTransCheckSave = await this.transRepo.update({assetAssignmentTransactionId: updateTransCheck.assetAssignmentTransactionId},{checkOut: moment(Date.now()).format('YYYY-MM-DD'),checkOutReason: req.checkOutReason})

            // }
            const transDto = new AssetAssignmentTransactionDto();
            transDto.assetAssignmentId = updateCheck.assetAssignmentId;
            transDto.assetLocationId = assetLocationMappingObj.asset_location_id;
            transDto.employeeId = updateTransCheck.employeeId;
            transDto.checkIn = req.checkIn;
            transDto.checkOut = new Date();
            transDto.checkOutReason = req.checkOutReason;
            transDto.assetsId = actAssetId;
            transDto.status = 'CHECKOUT'
            const transEntity = this.adapter.convertDtoToAssetAssignmentTransactionEntity(transDto)
            const assetAssignmentTrans = await this.transRepo.save(transEntity);
            const saveObject = await this.assetsRepository.findOne({ where: { assetId: actAssetId } })
            let assetId: number;
            if (saveObject) {
                const statusSave = await this.assetsRepository.update({ assetId: actAssetId }, { status: AssetStatusEnum.INSTOCK, lastCheckOut: moment(Date.now()).format('YYYY-MM-DD HH:mm:ss'), transactionDate: moment(Date.now()).format('YYYY-MM-DD HH:mm:ss') })
                assetId = saveObject.assetId
            }
            const assetTransDto = new AssetTransactionDto();
            assetTransDto.employeeId = updateTransCheck.employeeId;
            assetTransDto.lastCheckIn = req.checkIn;
            assetTransDto.lastCheckOut = new Date();
            assetTransDto.status = AssetStatusEnum.INSTOCK;
            assetTransDto.assetId = actAssetId;
            assetTransDto.transactionDate = new Date();
            const assetTransEntity = this.assetTransAdapter.convertAssetTransactionDtoToEntity(assetTransDto)
            const statusTransactionSave = await this.assetsTransactionRepo.save(assetTransEntity)
            return new CommonResponse(true, 1, 'Successfully updated')
        }

    }

    async getAssetByCode(req: AssetByAssetCode): Promise<CommonResponse> {
        const manager = getManager();
        let getEntities = `
        SELECT asas.asset_id,it.item_name AS assets_name,aas.assets_code, emp.employee_name,emp.mobile_no, emp.department_id , asas.check_in,locc.location_id,lo.location_id ,loc.location_name ,dep.dept_name,aas.plant,unc.unit_name,aas.asset_category,aas.asset_type,isc.item_sub_category,asas.employee_id,aas.asset_invoice_no,aas.asset_serialno,datediff(date(now()),asas.check_in) as aging,aas.asset_mode
        FROM `+ appSettings.assets_db + `.asset_assignment asas
        LEFT JOIN `+ appSettings.masters_db + `.employee_details emp ON emp.employee_id = asas.employee_id
        LEFT JOIN `+ appSettings.assets_db + `.assets aas ON aas.asset_id = asas.asset_id
        LEFT JOIN `+ appSettings.masters_db + `.items it ON it.item_id = aas.assets_name
        LEFT JOIN `+ appSettings.assets_db + `.asset_location_mapping lo ON lo.asset_id = aas.asset_id
        LEFT JOIN `+ appSettings.assets_db + `.location loc ON loc.location_id = lo.location_id
        LEFT JOIN `+ appSettings.assets_db + `.location locc ON locc.location_id = aas.asset_id
        LEFT JOIN `+ appSettings.masters_db + `.departments dep ON dep.dept_id = emp.department_id
        LEFT JOIN `+ appSettings.masters_db + ` .unitcodes unc ON unc.unit_code_id = aas.plant
        LEFT JOIN `+ appSettings.masters_db + `.item_sub_categories isc ON isc.item_sub_category_id = aas.asset_category
        WHERE asas.check_out IS NULL `;
        if (req.assetsCode) {
            getEntities = getEntities + 'and aas.assets_code = "' + req.assetsCode + '"'
        }
        if (req.location) {
            getEntities = getEntities + 'and loc.location_name = "' + req.location + '"'
        }
        if (req.assetType) {
            getEntities = getEntities + 'and aas.asset_type = "' + req.assetType + '"'
        }
        if (req.department) {
            getEntities = getEntities + 'and dep.dept_name = "' + req.department + '"'
        }
        if (req.assetCategory) {
            getEntities = getEntities + 'and isc.item_sub_category = "' + req.assetCategory + '"'
        }
        if (req.employeeId) {
            getEntities = getEntities + 'and asas.employee_id = ' + req.employeeId + ''
        }
        // if(req?.plantId && req.location){
        //     getEntities = getEntities + 'and aas.plant = ' + req.plantId +' and loc.location_name = "' + req.location +'"'
        // }
        // if(req.plantId && req.assetsCode){
        //     getEntities = getEntities + 'and aas.plant = ' + req.plantId +' and aas.assets_code = "' + req.assetsCode +'"'
        // }
        if (req.plantId > 0 && req.plantId != 5) {
            getEntities = getEntities + ' and aas.plant = ' + req.plantId + ''
        }
        getEntities = getEntities + ` ORDER BY it.item_name ASC `
        const assetdata: { asset_id: number, assets_name: string, assets_code: string, employee_name: string, mobile_no: string, department_id: number, check_in: Date, location_name: string, dept_name: string, unit_name: string, item_sub_category: string, asset_type: string, asset_invoice_no: string, asset_serialno: string, aging: string, asset_mode: string }[] = await manager.query(getEntities);
        const response = [];
        assetdata.forEach(data => {
            response.push(new AssignmentDto(null, null, data.asset_id, null, data.mobile_no, data.dept_name, true, null, data.check_in, data.assets_code, data.assets_name, data.location_name, data.employee_name, data.unit_name, data.item_sub_category, data.asset_type, null, data.aging, data.asset_invoice_no, data.asset_serialno, data.asset_mode))
        })
        return new CommonResponse(true, 1, 'Data retrieved successfully', response)

    }

    async getAllCheckIn(): Promise<CommonResponse> {
        const manager = getManager();
        const qry = `SELECT asas.asset_id,it.item_name AS assets_name,aas.assets_code, emp.employee_name,emp.mobile_no, emp.department_id , asas.check_in,locc.location_id,lo.location_id ,loc.location_name ,dep.dept_name,aas.plant,unc.unit_name,aas.asset_category,aas.asset_type,isc.item_sub_category
        FROM `+ appSettings.assets_db + `.asset_assignment asas
        LEFT JOIN `+ appSettings.masters_db + `.employee_details emp ON emp.employee_id = asas.employee_id
        LEFT JOIN `+ appSettings.assets_db + `.assets aas ON aas.asset_id = asas.asset_id
        LEFT JOIN `+ appSettings.masters_db + `.items it ON it.item_id = aas.assets_name
        LEFT JOIN `+ appSettings.assets_db + `.asset_location_mapping lo ON lo.asset_location_id = aas.asset_id
        LEFT JOIN `+ appSettings.assets_db + `.location loc ON loc.location_id = lo.location_id
        LEFT JOIN `+ appSettings.assets_db + `.location locc ON locc.location_id = aas.asset_id
        LEFT JOIN `+ appSettings.masters_db + `.departments dep ON dep.dept_id = emp.department_id
        LEFT JOIN `+ appSettings.masters_db + ` .unitcodes unc ON unc.unit_code_id = aas.plant
        LEFT JOIN `+ appSettings.masters_db + `.item_sub_categories isc ON isc.item_sub_category_id = aas.asset_category
        WHERE asas.check_out IS NULL
        ORDER BY assets_name ASC`
        const assetdata: { asset_id: number, assets_name: string, assets_code: string, employee_name: string, mobile_no: string, department_id: number, check_in: Date, location_name: string, dept_name: string, unit_name: string, item_sub_category: string, asset_type: string }[] = await manager.query(qry);
        const response = [];
        assetdata.forEach(data => {
            response.push(new AssignmentDto(null, null, data.asset_id, null, data.mobile_no, data.dept_name, true, null, data.check_in, data.assets_code, data.assets_name, data.location_name, data.employee_name, data.unit_name, data.item_sub_category, data.asset_type))
        })
        return new CommonResponse(true, 1, 'Data retrieved successfully', response)
    }

    async getAllTrans(): Promise<CommonResponse> {
        const manager = getManager();
        const qry = `SELECT asas.asset_id,it.item_name AS assets_name,aas.assets_code,aas.asset_cost,aas.asset_category, emp.employee_name,emp.mobile_no, emp.department_id, asas.check_in,asas.check_out,locc.location_id,lo.location_id ,loc.location_name, isc.item_sub_category,dep.dept_name,asas.status,aas.plant,unc.unit_name,aas.asset_type
        FROM `+ appSettings.assets_db + `.asset_assignment_transactions asas
        LEFT JOIN `+ appSettings.masters_db + `.employee_details emp ON emp.employee_id = asas.employee_id
        LEFT JOIN `+ appSettings.assets_db + `.assets aas ON aas.asset_id = asas.asset_id
        LEFT JOIN `+ appSettings.masters_db + `.items it ON it.item_id = aas.assets_name
        LEFT JOIN `+ appSettings.assets_db + `.asset_location_mapping lo ON lo.asset_location_id = aas.asset_id
        LEFT JOIN `+ appSettings.assets_db + `.location loc ON loc.location_id = lo.location_id
        LEFT JOIN `+ appSettings.assets_db + `.location locc ON locc.location_id = aas.asset_id
        LEFT JOIN `+ appSettings.masters_db + `.item_sub_categories isc ON isc.item_sub_category_id = aas.asset_category
        LEFT JOIN `+ appSettings.masters_db + `.departments dep ON dep.dept_id = emp.department_id
        LEFT JOIN `+ appSettings.masters_db + ` .unitcodes unc ON unc.unit_code_id = aas.plant
        ORDER BY assets_name ASC`
        const assetdata: { asset_id: number, assets_name: string, assets_code: string, employee_name: string, mobile_no: string, check_in: Date, location_name: string, check_out: Date, item_sub_category: string, asset_cost: string, dept_name: string, status: string, unit_name: string, asset_type: string }[] = await manager.query(qry);
        const response = [];
        assetdata.forEach(data => {
            response.push(new AssignmentTransactionDto(null, null, null, data.asset_id, null, true, null, data.check_in, data.assets_code, data.assets_name, data.location_name, data.employee_name, data.check_out, data.mobile_no, data.dept_name, data.asset_cost, data.item_sub_category, data.status, data.unit_name, data.asset_type))
        })
        return new CommonResponse(true, 1, 'Data retrieved successfully', response)
    }


    async getTransById(req: AssetByAssetCode): Promise<CommonResponse> {
        const manager = getManager();
        let getEntities = `SELECT asas.asset_id,it.item_name AS assets_name,aas.assets_code,aas.asset_cost,aas.asset_category, emp.employee_name,emp.mobile_no, emp.department_id, asas.check_in,asas.check_out,locc.location_id,lo.location_id ,loc.location_name, isc.item_sub_category,dep.dept_name,asas.status,aas.plant,unc.unit_name,aas.asset_type,aas.asset_serialno,aas.asset_invoice_no,aas.asset_mode
        FROM `+ appSettings.assets_db + `.asset_assignment_transactions asas
        LEFT JOIN `+ appSettings.masters_db + `.employee_details emp ON emp.employee_id = asas.employee_id
        LEFT JOIN `+ appSettings.assets_db + `.assets aas ON aas.asset_id = asas.asset_id
        LEFT JOIN `+ appSettings.masters_db + `.items it ON it.item_id = aas.assets_name
        LEFT JOIN `+ appSettings.assets_db + `.asset_location_mapping lo ON lo.asset_location_id = aas.asset_id
        LEFT JOIN `+ appSettings.assets_db + `.location loc ON loc.location_id = lo.location_id
        LEFT JOIN `+ appSettings.assets_db + `.location locc ON locc.location_id = aas.asset_id
        LEFT JOIN `+ appSettings.masters_db + `.item_sub_categories isc ON isc.item_sub_category_id = aas.asset_category
        LEFT JOIN `+ appSettings.masters_db + `.departments dep ON dep.dept_id = emp.department_id
        LEFT JOIN `+ appSettings.masters_db + ` .unitcodes unc ON unc.unit_code_id = aas.plant
        WHERE aas.asset_id>0 `
        if (req.assetsCode) {
            getEntities = getEntities + 'and aas.assets_code = "' + req.assetsCode + '"'
        }
        if (req.plant) {
            getEntities = getEntities + 'and unc.unit_name = "' + req.plant + '"'
        }
        if (req.location) {
            getEntities = getEntities + 'and loc.location_name = "' + req.location + '"'
        }
        if (req.assetType) {
            getEntities = getEntities + 'and aas.asset_type = "' + req.assetType + '"'
        }
        if (req.department) {
            getEntities = getEntities + 'and dep.dept_name = "' + req.department + '"'
        }
        if (req.assetCategory) {
            getEntities = getEntities + 'and isc.item_sub_category = "' + req.assetCategory + '"'
        }
        if (req.employeeId) {
            getEntities = getEntities + 'and asas.employee_id = ' + req.employeeId + ''
        }
        if (req.plant && req.location) {
            getEntities = getEntities + 'and unc.unit_name = "' + req.plant + '" and loc.location_name = "' + req.location + '"'
        }
        if (req.plantId > 0 && req.plantId != 5) {
            getEntities = getEntities + 'and aas.plant = ' + req.plantId
        }
        if (req.fromDate) {
            getEntities = getEntities + 'and asas.check_in BETWEEN "' + req.fromDate + '" AND "' + req.toDate + '"'

        }
        if (req.fromDate) {
            getEntities = getEntities + ` ORDER BY asas.check_in ASC `
        } else {
            getEntities = getEntities + ` ORDER BY it.item_name ASC `
        }
        // getEntities = getEntities + ` ORDER BY it.item_name ASC `

        const assetdata: { asset_id: number, assets_name: string, assets_code: string, employee_name: string, mobile_no: string, check_in: Date, location_name: string, check_out: Date, item_sub_category: string, asset_cost: string, dept_name: string, unit_name: string, status: string, asset_type: string, asset_invoice_no: string, asset_serialno: string, asset_mode: string }[] = await manager.query(getEntities);
        const response = [];
        assetdata.forEach(data => {
            response.push(new AssignmentTransactionDto(null, null, null, data.asset_id, null, true, null, data.check_in, data.assets_code, data.assets_name, data.location_name, data.employee_name, data.check_out, data.mobile_no, data.dept_name, data.asset_cost, data.item_sub_category, data.status, data.unit_name, data.asset_type, data.asset_invoice_no, data.asset_serialno, data.asset_mode))
        })
        return new CommonResponse(true, 1, 'Data retrieved successfully', response)

    }

    async getByDate(req: AssetByDate): Promise<CommonResponse> {
        const getReqDto: AssetAssignmentTransactionDto[] = [];
        const responseEntities = await this.transRepo.find({
            where: {
                checkIn: Between(req.fromDate, req.toDate),
                checkOut: Between(req.fromDate, req.toDate)
            }
        })
        if (responseEntities.length) {
            for (const getEntity of responseEntities) {
                const convertedDto: AssetAssignmentTransactionDto = this.adapter.convertEntityToTransDto(getEntity)

                const getEntities: { assets_name: number, assets_code: string, asset_category: number, location_name: string } =
                    await this.assetsRepository.createQueryBuilder('asset')
                        .select('assets_name, assets_code,asset_category, location_name')
                        .leftJoin('asset.assetsLocation', 'locmap')
                        .leftJoin(Location, 'loc', 'loc.location_id = locmap.location_id')
                        .where(`asset.asset_id = '${getEntity.assetsId}'`)
                        .orderBy('asset.asset_id')
                        .getRawOne();

                convertedDto.assetsId = getEntity.assetsId;
                convertedDto.assetName = getEntities.assets_name;
                convertedDto.assetsCode = getEntities.assets_code;
                convertedDto.location = getEntities.location_name;
                const qry = `select employee_name ,mobile_no from ${appSettings.masters_db}.employee_details where employee_id = ${convertedDto.employeeId}`;
                const manager = getManager();
                const data: { employee_name: string, mobile_no: string }[] = await manager.query(qry);
                convertedDto.employeeName = data[0].employee_name;
                convertedDto.employeePhNum = data[0].mobile_no;
                const qry1 = `select item_name from ${appSettings.masters_db}.items where item_id = ${convertedDto.assetName}`;
                const data1: { item_name: string }[] = await manager.query(qry1);
                convertedDto.itemName = data1[0].item_name;
                const qry2 = `select item_sub_category from ${appSettings.masters_db}.item_sub_categories where item_sub_category_id = ${getEntities.asset_category}`;
                const data2: { item_sub_category: string }[] = await manager.query(qry2)
                convertedDto.assetCategory = data2[0].item_sub_category;
                getReqDto.push(convertedDto);
            }
            return new CommonResponse(true, 98898, 'Requests retrieved successfully', getReqDto);
        } else {
            return new CommonResponse(false, 11101, 'No data found');
        }
    }

    async getPlantsForAssetService(): Promise<CommonResponse> {
        const manager = getManager()
        let query = `SELECT a.plant AS plantId , uc.unit_name AS plant  FROM ` + appSettings.assets_db + `.assets a
        LEFT JOIN `+ appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id = a.plant GROUP BY a.plant`

        const data = await manager.query(query)
        if (query?.length) {
            return new CommonResponse(true, 1111, 'Data Retried Successfully', data);
        } else {
            throw new ErrorResponse(9999, 'No Data Found');
        }
    }
    async getLocationsForAssetService(req?: AssetServiceReq): Promise<CommonResponse> {
        const manager = getManager()
        let query = ` SELECT a.plant AS plantId , lm.location_id AS locationId , uc.unit_name AS plant , l.location_name AS locationName FROM ` + appSettings.assets_db + `.assets a
        LEFT JOIN `+ appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id = a.plant 
        LEFT JOIN `+ appSettings.assets_db + `.asset_location_mapping lm ON lm.asset_id = a.asset_id
        LEFT JOIN `+ appSettings.assets_db + `.location l ON l.location_id = lm.location_id 
        WHERE lm.location_id > 0 `;
        if (req.plant > 0) {
            query = query + ' and a.plant = ' + req.plant;
        }
        query = query + ` GROUP BY l.location_name `
        const data = await manager.query(query)
        if (query?.length) {
            return new CommonResponse(true, 1111, 'Data Retried Successfully', data);
        } else {
            throw new ErrorResponse(9999, 'No Data Found');
        }
    }

    async getAssetsCodeForAssetService(req?: AssetServiceReq): Promise<CommonResponse> {
        const manager = getManager()
        let query = `SELECT a.assets_name AS assetId , i.item_name AS assetName , a.assets_code AS assetCode,concat(a.assets_code,'-',i.item_name) as name FROM ` + appSettings.assets_db + `.assets a
        LEFT JOIN `+ appSettings.masters_db + `.item_sub_categories ic ON ic.item_sub_category_id = a.asset_category
        LEFT JOIN `+ appSettings.masters_db + `.items i ON i.item_id = a.assets_name 
        WHERE a.assets_name> 0 GROUP BY a.assets_code ORDER BY i.item_name ASC`;
        const data = await manager.query(query)
        if (query?.length) {
            return new CommonResponse(true, 1111, 'Data Retried Successfully', data);
        } else {
            throw new ErrorResponse(9999, 'No Data Found');
        }
    }

    async getReadyForAssetService(req?: AssetServiceReq): Promise<CommonResponse> {
        const manager = getManager()
        let query = `SELECT a.asset_id AS assetId,a.assets_name as assetName ,asr.service_name as serviceName, i.item_name AS assetName , a.assets_code AS assetCode ,ic.item_sub_category AS assetCategory , a.plant as plantId , uc.unit_name AS plant ,l.location_id as locationId , l.location_name AS locationName, i.asset_type AS assetType , a.service_tenure AS serviceTenure , a.created_at AS assetCreateDate ,asr.asset_service_date  AS serviceDate , a.status AS assetStatus , a.service_status AS serviceStatus,asr.status,asr.asset_serve_id as assetServiceId,asr.remarks,asr.service_name as serviceName,asr.service_provider as serviceProvider,asr.start_date as startDate,asr.completed_date as completedDate FROM ` + appSettings.assets_db + `.asset_service asr
        LEFT JOIN ${appSettings.assets_db}.assets a on a.asset_id = asr.asset_id
        LEFT JOIN `+ appSettings.masters_db + `.item_sub_categories ic ON ic.item_sub_category_id = a.asset_category
        LEFT JOIN `+ appSettings.masters_db + `.items i ON i.item_id = a.assets_name 
        LEFT JOIN `+ appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id = a.plant
        LEFT JOIN `+ appSettings.assets_db + `.asset_location_mapping lm ON lm.asset_id = a.asset_id
        LEFT JOIN `+ appSettings.assets_db + `.location l ON l.location_id = lm.location_id 
        WHERE a.assets_name> 0 and  (DATE(asr.asset_service_date) >= DATE(CURDATE()) OR (DATE(asr.asset_service_date) < DATE(CURDATE())) and asr.status != 'OPEN') `;
        if (req?.plantId && req.plantId != 5) {
            query = query + ' and a.plant = ' + req?.plantId;
        }
        if (req?.location > 0) {
            query = query + ' and l.location_id = ' + req?.location;
        }
        if (req?.assetId) {
            query = query + ' and a.assets_code = "' + req?.assetId + '"';
        }
        query = query + ' order by asr.asset_service_date ASC'

        const data = await manager.query(query)
        if (query?.length) {
            return new CommonResponse(true, 1111, 'Data Retried Successfully', data);
        } else {
            throw new ErrorResponse(9999, 'No Data Found');
        }
    }
    async getServiceOverdue(req?: AssetServiceReq): Promise<CommonResponse> {
        const manager = getManager()
        let query = `SELECT a.assets_name AS assetId , i.item_name AS assetName , a.assets_code AS assetCode ,
        ic.item_sub_category AS assetCategory , a.plant AS plantId , uc.unit_name AS plant ,
        l.location_id AS locationId , l.location_name AS locationName, i.asset_type AS assetType ,
         a.service_tenure AS serviceTenure , DATE(a.created_at) AS assetCreateDate , 
         DATE(DATE_ADD( a.created_at,INTERVAL a.service_tenure DAY )) AS serviceDate , a.status AS assetStatus , 
         a.service_status AS serviceStatus,asr.status,DATEDIFF( DATE_ADD( a.created_at,INTERVAL a.service_tenure DAY ), NOW())AS age 
         FROM ` + appSettings.assets_db + `.asset_service asr
        LEFT JOIN ${appSettings.assets_db}.assets a on a.asset_id = asr.asset_id
        LEFT JOIN `+ appSettings.masters_db + `.item_sub_categories ic ON ic.item_sub_category_id = a.asset_category
        LEFT JOIN `+ appSettings.masters_db + `.items i ON i.item_id = a.assets_name 
        LEFT JOIN `+ appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id = a.plant
        LEFT JOIN `+ appSettings.assets_db + `.asset_location_mapping lm ON lm.asset_id = a.asset_id
        LEFT JOIN `+ appSettings.assets_db + `.location l ON l.location_id = lm.location_id 
        WHERE a.assets_name> 0 and DATE(asr.asset_service_date) <= DATE(CURDATE()) and asr.status = 'OPEN' `;

        if (req?.plantId > 0) {
            query = query + ' and a.plant = ' + req?.plantId;
        }
        if (req?.assetCode) {
            query = query + ' and a.assets_code = "' + req?.assetCode + '"'
        }
        if (req?.location > 0) {
            query = query + ' and l.location_id = ' + req?.location;
        }
        if (req?.assetId) {
            query = query + ' and a.assets_code = "' + req?.assetId + '"';
        }
        if (req?.assetType) {
            query = query + ' and i.asset_type = "' + req?.assetType + '"';
        }
        if (req?.assetCategory) {
            query = query + ' and a.asset_category = "' + req?.assetCategory + '"';
        }
         query = query + ' GROUP BY a.assets_code ORDER BY i.item_name ASC';
        const data = await manager.query(query)
        if (query?.length) {
            return new CommonResponse(true, 1111, 'Data Retried Successfully', data);
        } else {
            throw new ErrorResponse(9999, 'No Data Found');
        }
    }
    async getDataForServiceCalender(req: UnitRequest): Promise<CommonResponse> {
        const manager = getManager()
        let query;
        query = `SELECT  a.asset_id AS assetId,i.item_name AS assetName,a.assets_code AS assetCode ,ic.item_sub_category AS assetCategory,a.created_at AS assetCreateDate,a.expired_date as expiredDate,a.owner_of_asset as ownerOfAsset,dep.dept_name as deptName ,loc.location_name as locationName,uc.unit_name as plantName, a.asset_service_date as actualServiceDate,empo.employee_name as employeeName,asr.service_provider as serviceProvider,a.frequency_of_service as frequencyOfService,a.month,a.day,a.service_type as serviceType,asr.status as serviceStatus,asr.asset_service_date as assetServiceDate,asr.asset_serve_id as assetServiceId,asr.service_name as serviceName,asr.remarks,asr.service_provider as serviceProvider,a.model,asr.service_owner as serviceOwner,asr.phone_number as phoneNumber,asr.remarks as remarks from ` + appSettings.assets_db + `.asset_service asr
        LEFT JOIN `+ appSettings.assets_db + `.assets a on a.asset_id = asr.asset_id 
        LEFT JOIN `+ appSettings.masters_db + `.item_sub_categories ic ON ic.item_sub_category_id = a.asset_category
        LEFT JOIN `+ appSettings.masters_db + `.items i ON i.item_id = a.assets_name 
        LEFT JOIN `+ appSettings.masters_db + `.employee_details emp ON emp.employee_id = a.employee_id 
        LEFT JOIN `+ appSettings.masters_db + `.departments dep ON dep.dept_id = emp.department_id 
        LEFT JOIN `+ appSettings.assets_db + `.asset_location_mapping alm ON alm.asset_id = a.asset_id 
        LEFT JOIN `+ appSettings.assets_db + `.location loc ON loc.location_id = alm.location_id
        LEFT JOIN `+ appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id = a.plant
        LEFT JOIN `+ appSettings.masters_db + `.employee_details empo ON empo.employee_id = a.owner_of_asset `
        if (req.unitId && req.unitId != 5) {
            query = query + ` where a.plant = ${req.unitId}`
        }
        const data = await manager.query(query)
        if (data && data?.length) {
            return new CommonResponse(true, 1111, 'Data Retried Successfully', data);
        } else {
            throw new ErrorResponse(9999, 'No Data Found');
        }
    }
    async getWarrantyAndInsuranceDate(req: UnitRequest): Promise<CommonResponse> {
        const manager = getManager()
        let query = `SELECT i.item_name AS assetName, a.insurance_date as insuranceDate , a.warrenty_expired_date as warrentyDate FROM ` + appSettings.assets_db + `.assets a 
        LEFT JOIN `+ appSettings.masters_db + `.items i ON i.item_id = a.assets_name `
        if (req.unitId && req.unitId != 5) {
            query = query + ` where a.plant = ${req.unitId}`
        }
        const data = await manager.query(query)
        if (query?.length) {
            return new CommonResponse(true, 1111, 'Data Retried Successfully', data);
        } else {
            throw new ErrorResponse(9999, 'No Data Found');
        }
    }

    async getAssignmentTransAssetCodesDropDown(req?: AssetByAssetCode): Promise<CommonResponse> {
        const manager = getManager();
        let getEntities = `SELECT asas.asset_id,it.item_name AS assets_name,aas.assets_code
        FROM `+ appSettings.assets_db + `.asset_assignment_transactions asas
        LEFT JOIN `+ appSettings.assets_db + `.assets aas ON aas.asset_id = asas.asset_id
        LEFT JOIN `+ appSettings.masters_db + `.items it ON it.item_id = aas.assets_name
        LEFT JOIN `+ appSettings.masters_db + ` .unitcodes unc ON unc.unit_code_id = aas.plant
        WHERE aas.asset_id>0 `
        if (req.plantId > 0 && req.plantId != 5) {
            getEntities = getEntities + 'and aas.plant = ' + req.plantId
        }
        getEntities = getEntities + ` GROUP BY aas.assets_code ORDER BY it.item_name ASC`
        const result = await manager.query(getEntities);
        if (result.length > 0) {
            return new CommonResponse(true, 11608, 'Data Retrived Sucessfullyy.....', result)
        }
        else {
            return new CommonResponse(false, 11608, 'No data Found', result)
        }

    }

    async getInactiveReport(req: AssetByAssetCode): Promise<CommonResponse> {
        const manager = getManager();
        let getEntities = `
        SELECT asas.asset_id,it.item_name AS assets_name,aas.assets_code, emp.employee_name,emp.mobile_no, emp.department_id , asas.check_in,locc.location_id,lo.location_id ,loc.location_name ,dep.dept_name,aas.plant,unc.unit_name,aas.asset_category,aas.asset_type,isc.item_sub_category,asas.employee_id,emp.updated_at,datediff(date(now()),emp.updated_at) as aging
        FROM `+ appSettings.assets_db + `.asset_assignment asas
        LEFT JOIN `+ appSettings.masters_db + `.employee_details emp ON emp.employee_id = asas.employee_id
        LEFT JOIN `+ appSettings.assets_db + `.assets aas ON aas.asset_id = asas.asset_id
        LEFT JOIN `+ appSettings.masters_db + `.items it ON it.item_id = aas.assets_name
        LEFT JOIN `+ appSettings.assets_db + `.asset_location_mapping lo ON lo.asset_location_id = aas.asset_id
        LEFT JOIN `+ appSettings.assets_db + `.location loc ON loc.location_id = lo.location_id
        LEFT JOIN `+ appSettings.assets_db + `.location locc ON locc.location_id = aas.asset_id
        LEFT JOIN `+ appSettings.masters_db + `.departments dep ON dep.dept_id = emp.department_id
        LEFT JOIN `+ appSettings.masters_db + ` .unitcodes unc ON unc.unit_code_id = aas.plant
        LEFT JOIN `+ appSettings.masters_db + `.item_sub_categories isc ON isc.item_sub_category_id = aas.asset_category
        WHERE asas.check_out IS NULL and emp.is_active = 0 `;
        if (req.assetsCode) {
            getEntities = getEntities + 'and aas.assets_code = "' + req.assetsCode + '"'
        }
        if (req.location) {
            getEntities = getEntities + 'and loc.location_name = "' + req.location + '"'
        }
        if (req.assetType) {
            getEntities = getEntities + 'and aas.asset_type = "' + req.assetType + '"'
        }
        if (req.department) {
            getEntities = getEntities + 'and dep.dept_name = "' + req.department + '"'
        }
        if (req.assetCategory) {
            getEntities = getEntities + 'and isc.item_sub_category = "' + req.assetCategory + '"'
        }
        if (req.employeeId) {
            getEntities = getEntities + 'and asas.employee_id = ' + req.employeeId + ''
        }
        // if(req?.plantId && req.location){
        //     getEntities = getEntities + 'and aas.plant = ' + req.plantId +' and loc.location_name = "' + req.location +'"'
        // }
        // if(req.plantId && req.assetsCode){
        //     getEntities = getEntities + 'and aas.plant = ' + req.plantId +' and aas.assets_code = "' + req.assetsCode +'"'
        // }
        if (req.plantId > 0 && req.plantId != 5) {
            getEntities = getEntities + 'and aas.plant = ' + req.plantId + ''
        }
        if (req.aging != undefined) {
            if (req.aging == '0-30') {
                getEntities = getEntities + 'having aging between 0 and 30'
            }
            if (req.aging == '31-60') {
                getEntities = getEntities + 'having aging between 31 and 60'
            }
            if (req.aging == '61-100') {
                getEntities = getEntities + 'having aging between 61 and 100'
            }
        }
        if (req.aging != undefined) {
            getEntities = getEntities + ` ORDER BY aging ASC `
        } else {
            getEntities = getEntities + ` ORDER BY it.item_name ASC `
        }
        const assetdata: { asset_id: number, assets_name: string, assets_code: string, employee_name: string, mobile_no: string, department_id: number, check_in: Date, location_name: string, dept_name: string, unit_name: string, item_sub_category: string, asset_type: string, updated_at: Date, aging: string }[] = await manager.query(getEntities);
        const response = [];
        assetdata.forEach(data => {
            response.push(new AssignmentDto(null, null, data.asset_id, null, data.mobile_no, data.dept_name, true, null, data.check_in, data.assets_code, data.assets_name, data.location_name, data.employee_name, data.unit_name, data.item_sub_category, data.asset_type, data.updated_at, data.aging))
        })
        return new CommonResponse(true, 1, 'Data retrieved successfully', response)

    }

    async getInactiveReportDropDown(req?: AssetByAssetCode): Promise<CommonResponse> {
        const manager = getManager();
        let Query = `
    SELECT asas.asset_id,it.item_name AS assets_name,aas.assets_code
    FROM `+ appSettings.assets_db + `.asset_assignment asas
    LEFT JOIN `+ appSettings.masters_db + `.employee_details emp ON emp.employee_id = asas.employee_id
    LEFT JOIN `+ appSettings.assets_db + `.assets aas ON aas.asset_id = asas.asset_id
    LEFT JOIN `+ appSettings.masters_db + `.items it ON it.item_id = aas.assets_name
    WHERE asas.check_out IS NULL and emp.is_active = 0 `;
        if (req.plantId > 0 && req.plantId != 5) {
            Query = Query + 'and a.plant = ' + req.plantId
        }
        Query = Query + ` GROUP BY aas.assets_code ORDER BY it.item_name ASC`
        const result = await manager.query(Query);
        if (result.length > 0) {
            return new CommonResponse(true, 11608, 'Data Retrived Sucessfullyy.....', result)
        }
        else {
            return new CommonResponse(false, 11608, 'No data Found', result)
        }

    }

    async getMissedAssetServices(req?: AssetServiceReq): Promise<CommonResponse> {
        const manager = getManager()
        let query = `SELECT a.assets_name AS assetId , i.item_name AS assetName , a.assets_code AS assetCode ,ic.item_sub_category AS assetCategory , a.plant as plantId , uc.unit_name AS plant ,l.location_id as locationId , l.location_name AS locationName, i.asset_type AS assetType , a.service_tenure AS serviceTenure , a.created_at AS assetCreateDate ,asr.asset_service_date  AS serviceDate , a.status AS assetStatus , a.service_status AS serviceStatus,asr.status,asr.asset_serve_id as assetServiceId,asr.service_name as serviceName FROM ` + appSettings.assets_db + `.asset_service asr
    LEFT JOIN ${appSettings.assets_db}.assets a on a.asset_id = asr.asset_id
    LEFT JOIN `+ appSettings.masters_db + `.item_sub_categories ic ON ic.item_sub_category_id = a.asset_category
    LEFT JOIN `+ appSettings.masters_db + `.items i ON i.item_id = a.assets_name 
    LEFT JOIN `+ appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id = a.plant
    LEFT JOIN `+ appSettings.assets_db + `.asset_location_mapping lm ON lm.asset_id = a.asset_id
    LEFT JOIN `+ appSettings.assets_db + `.location l ON l.location_id = lm.location_id 
    WHERE  DATE(asr.asset_service_date) < DATE(CURDATE()) AND asr.status = 'OPEN' `;
        if (req?.plant && req.plant != 5) {
            query = query + ' and a.plant = ' + req?.plant;
        }
        if (req?.location > 0) {
            query = query + ' and l.location_id = ' + req?.location;
        }
        if (req?.assetId) {
            query = query + ' and a.assets_code = "' + req?.assetId + '"';
        }
        query = query + ' order by asr.asset_service_date DESC'

        const data = await manager.query(query)
        if (query?.length) {
            return new CommonResponse(true, 1111, 'Data Retried Successfully', data);
        } else {
            throw new ErrorResponse(9999, 'No Data Found');
        }
    }



}